import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { customTooltip } from '@/chart/chart-in-kpi-card-tooltip';
import { CHART_TO_COMPONENT } from '@/chart/components/all-charts';
import * as dataSelectors from '@/data/data-selectors';
import { Wrapper } from './chart-in-kpi-card-styles';

/**
 * Customized chart component based on ChartTemplate
 * just pass data and other configurations as props
 *
 */
function ChartInKpiCardComponent({ currentChartType, kpiData }) {
  const wrapperRef = useRef(null); // document.getByElementById behind the scence

  const Chart = CHART_TO_COMPONENT[currentChartType];
  return (
    <Wrapper ref={wrapperRef}>
      <Chart
        customTooltip={customTooltip(currentChartType, wrapperRef, kpiData)}
        applyOffset
      />
    </Wrapper>
  );
}

function mapStateToProps(state) {
  return {
    kpiData: dataSelectors.kpiData(state),
  };
}

export const ChartInKpiCard = connect(mapStateToProps)(ChartInKpiCardComponent);
